import { useHistory } from "react-router-dom";
import { Text } from "preact-i18n";

import { ModalForm } from "@revoltchat/ui";

import { getDisplayName } from "../../../lib/displayName";
import { TextReact } from "../../../lib/i18n";

import { getClientController } from "../../client/ClientController";
import { ModalProps } from "../types";

/**
 * Confirmation modal
 */
export default function Confirmation(
    props: ModalProps<
        | "close_dm"
        | "delete_server"
        | "delete_channel"
        | "delete_bot"
        | "delete_role"
        | "delete_category"
        | "block_user"
        | "unfriend_user"
    >,
) {
    const history = useHistory();

    const EVENTS = {
        close_dm: ["confirm_close_dm", "close"],
        delete_server: ["confirm_delete", "delete"],
        delete_channel: ["confirm_delete", "delete"],
        delete_bot: ["confirm_delete", "delete"],
        delete_role: ["confirm_delete", "delete"],
        delete_category: ["confirm_delete", "delete"],
        unfriend_user: ["unfriend_user", "remove"],
        block_user: ["block_user", "block"],
    };

    const event = EVENTS[props.type];
    let name;
    switch (props.type) {
        case "unfriend_user":
        case "block_user":
            name = getDisplayName(props.target);
            break;
        case "close_dm":
            name = getDisplayName(props.target.recipient);
            break;
        case "delete_bot":
        case "delete_role":
            name = props.name;
            break;
        case "delete_category":
            name = props.category.title;
            break;
        default:
            name = props.target.name;
    }

    return (
        <ModalForm
            {...props}
            title={
                <Text
                    id={`app.special.modals.prompt.${event[0]}`}
                    fields={{ name }}
                />
            }
            description={
                <TextReact
                    id={`app.special.modals.prompt.${event[0]}_long`}
                    fields={{ name: <b>{name}</b> }}
                />
            }
            data={{}}
            schema={{}}
            callback={async () => {
                switch (props.type) {
                    case "unfriend_user":
                        await props.target.removeFriend();
                        break;
                    case "block_user":
                        await props.target.blockUser();
                        break;
                    case "close_dm":
                    case "delete_channel":
                    case "delete_server":
                        if (props.type != "delete_channel") history.push("/");

                        props.target.delete();
                        break;
                    case "delete_bot":
                        getClientController().availableClient.bots.delete(
                            props.target,
                        );
                        props.cb?.();
                        break;
                    case "delete_role":
                        props.server.deleteRole(props.role_id);
                        break;
                    case "delete_category":
                        props.server.edit({
                            categories: (props.server.categories ?? []).filter(
                                (x) => x.id !== props.category.id,
                            ),
                        });
                        props.callback?.();
                        break;
                }
            }}
            submit={{
                palette: "error",
                children: (
                    <Text id={`app.special.modals.actions.${event[1]}`} />
                ),
            }}
        />
    );
}
